import { contributeToProfileDeclaration } from '@moojo/agent-worker-api'
import type { ServiceDeclaration } from '@moojo/endpoints'

import { attestPlaidCredentialsDeclaration } from './attest-plaid-credentials-api'
import { beskarPortalPageDeclaration } from './beskar-portal-page-api'
import { calibrateDeclaration } from './calibrate-api'
import { computeTargetingTagsFitDeclaration } from './compute-targeting-tags-fit-api'
import { computeUseCaseFitDeclaration } from './compute-use-case-fit-api'
import { isEligibleForDiscountDeclaration } from './discount-eligibility-api'
import { engageDeclaration } from './engage-api'
import { extractPersonalizedOfferDeclaration } from './extract-personalized-offer-api'
import { generateCouponLinkDeclaration } from './generate-coupon-link-api'
import { getCalibrationDeclaration } from './get-calibration-api'
import { getChatMaterialsDeclaration } from './get-chat-materials-api'
import { getFeedDeclaration } from './get-feed-api'
import { getUserActivityDeclaration } from './get-user-activity-api'
import { getUserProfileDeclaration } from './get-user-profile-api'
import { ingestMessageDeclaration } from './ingest-message'
import { issueDiscountCodeDeclaration } from './issue-discount-code-api'
import { quickLoginDeclaration } from './quick-login-api'
import { recommendConvoAdDeclaration } from './recommend-convo-ad-api'
import { refreshProductFeedsDeclaration } from './refresh-product-feeds-api'
import { serveDeclaration } from './serve-api'
import { startSessionDeclaration } from './session-api'
import { simulateServeDeclaration } from './simulate-serve-api'
import { submitAnswersDeclaration } from './submit-answers-api'

export const MoojoAgentServiceDeclaration = {
  'moojo-agent/is-eligible-for-discount': isEligibleForDiscountDeclaration,
  'moojo-agent/issue-discount-code': issueDiscountCodeDeclaration,
  'moojo-agent/generate-coupon-link': generateCouponLinkDeclaration,
  'moojo-agent/quick-login': quickLoginDeclaration,
  'moojo-agent/start-session': startSessionDeclaration,
  'moojo-agent/get-calibration': getCalibrationDeclaration,
  'moojo-agent/calibrate': calibrateDeclaration,
  'moojo-agent/attest-plaid-credentials': attestPlaidCredentialsDeclaration,
  'moojo-agent/extract-personalized-offer': extractPersonalizedOfferDeclaration,
  'moojo-agent/get-user-profile': getUserProfileDeclaration,
  'moojo-agent/get-user-activity': getUserActivityDeclaration,
  'moojo-agent/get-chat-materials': getChatMaterialsDeclaration,
  'moojo-agent/submit-answers': submitAnswersDeclaration,
  'moojo-agent/contribute-to-profile': contributeToProfileDeclaration,
  'moojo-agent/compute-targeting-tags-fit-score': computeTargetingTagsFitDeclaration,
  'moojo-agent/compute-use-case-fit': computeUseCaseFitDeclaration,
  'moojo-agent/beskar-portal-page': beskarPortalPageDeclaration,
  'moojo-agent/chat/ingest-message': ingestMessageDeclaration,
  'moojo-agent/ad/convo-recommend': recommendConvoAdDeclaration,
  'moojo-agent/ad/engage': engageDeclaration,
  'moojo-agent/ad/get-feed': getFeedDeclaration,
  'moojo-agent/ad/serve': serveDeclaration,
  'moojo-agent/ad/simulate-serve': simulateServeDeclaration,
  'refresh-product-feeds': refreshProductFeedsDeclaration,
}

export type MoojoAgentServiceDeclaration = ServiceDeclaration<typeof MoojoAgentServiceDeclaration>

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const makeEndpointUrl = (endpoint: keyof MoojoAgentServiceDeclaration, suffix?: string) =>
  `/${endpoint}${suffix ?? ''}`
